import React from "react";
import { Bling as GPT } from "react-gpt";
import ReactHtmlParser from "react-html-parser"; 
GPT.enableSingleRequest();
export default class Article_Middle_728_90 extends React.Component {
  render() {
    let AdData = this.props.AdsData;
    return (
      <>
       {ReactHtmlParser(AdData.banner_code)}
      </>
    );
  }
}
